const APP_NAME = import.meta.env.VITE_NAME ?? import.meta.env.REACT_APP_NAME;
const ENV = import.meta.env.VITE_ENVIRONMENT ?? import.meta.env.REACT_APP_ENVIRONMENT;
const IDENTITY_URL = import.meta.env.VITE_IDENTITY_API ?? import.meta.env.REACT_APP_IDENTITY_API;
const DEBUG = Boolean(import.meta.env.VITE_DEBUG ?? import.meta.env.REACT_APP_DEBUG);

const DEFAULT_MESSAGES = {
  ERROR: "Ha ocurrido un error. Inténtalo nuevamente",
};

export { APP_NAME, ENV, IDENTITY_URL, DEBUG, DEFAULT_MESSAGES };
